import { html } from "lit";

export default html`
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
    <path
      fill="currentColor"
      fill-rule="evenodd"
      d="M5.575 7.484a6.602 6.602 0 0 1 12.85 0 5.101 5.101 0 0 1 1.909 9.257.6.6 0 1 1-.668-.997 3.9 3.9 0 0 0-1.801-7.127.6.6 0 0 1-.537-.5 5.402 5.402 0 0 0-10.656 0 .6.6 0 0 1-.537.5 3.9 3.9 0 0 0-1.801 7.127.6.6 0 0 1-.668.997 5.101 5.101 0 0 1 1.909-9.257ZM12 11.4a.6.6 0 0 1 .6.6v7.552l2.976-2.976a.6.6 0 0 1 .848.848l-4 4a.6.6 0 0 1-.848 0l-4-4a.6.6 0 0 1 .848-.848l2.976 2.976V12a.6.6 0 0 1 .6-.6Z"
      clip-rule="evenodd"
    />
  </svg>
`;
